import React from 'react';

export default ({ blackFont = false, status, color, width, height, maxWidth }) => {
  return (
    <div
      style={{
        alignItems: 'center',
        backgroundColor: color,
        borderRadius: '5px',
        color: blackFont ? '#172B4D' : 'white',
        display: 'flex',
        fontSize: '12px',
        fontWeight: '500',
        height: height || '25px',
        justifyContent: 'center',
        maxWidth: maxWidth || '',
        width: width || '110px',
      }}>
      {status}
    </div>
  );
};
